import { CalculatorBase } from "./calculatorBase";


export class CalculatorBloodAlcohol extends CalculatorBase {
    el: JQuery;
    fForm: JQuery;
    fWeightKg: JQuery;
    fSex: JQuery;
    fTimeHr: JQuery;
    fAddAlcohol: JQuery;
    fAlcoholList: JQuery;
    fAlcoholEmptyList: JQuery;
    fResetList: JQuery;
    fReset: JQuery;
    fSubmit: JQuery;
    dError: JQuery;
    dResult: JQuery;

    constructor() {
        super("blood-alcohol");
        this.el = $("#calculator-blood-alcohol");
        if (this.el.length) {
            const eInputChange = this.inputChange.bind(this);

            this.fForm = $("#fForm", this.el).on("submit", this.calculate.bind(this));
            this.fWeightKg = $("#fWeightKg", this.el).on("change", eInputChange);
            this.fSex = $("#fSex", this.el).on("change", eInputChange);
            this.fTimeHr = $("#fTimeHr", this.el).on("change", eInputChange);
            this.fAddAlcohol = $("#fAddAlcohol", this.el).on("change", this.fAddAlcoholSelect.bind(this));
            this.fAlcoholList = $("#fAlcoholList", this.el);
            this.fAlcoholEmptyList = $("#fAlcoholEmptyList", this.el);
            this.fResetList = $("#fResetList", this.el).on("click", this.fAlcoholListClear.bind(this)).hide();
            this.fReset = $("#fReset", this.el).on("click", this.fAlcoholListClear.bind(this));
            this.fSubmit = $("#fSubmit", this.el);
            this.dError = $(".error", this.el);
            this.dResult = $(".result", this.el);
        }
    }

    inputChange(e: JQuery.ChangeEvent) {
        this.fWeightKg.parent().removeClass("has-error");
        this.fAddAlcohol.parent().removeClass("has-error");
        this.dError.hide().html("");
        this.dResult.hide().html("");
    }

    fAddAlcoholSelect(e: JQuery.SelectEvent) {
        const el = $(e.target);
        const elOption = el.find("option:selected");
        const elX = $("<span />", { "class": "badge small glyphicon glyphicon-remove", text: " " });
        const elButton = $("<button />", { "class": "list-group-item btn-sm", text: elOption.text() + " " })
            .data("value", elOption.val())
            .append(elX)
            .on("click", this.fAlcoholListDeleteItem.bind(this));
        this.fAlcoholList.append(elButton);
        el.val("");
        this.inputChange(null);
        this.fAlcoholEmptyList.hide();
        this.fResetList.show();
    }

    fAlcoholListDeleteItem(e: JQuery.ClickEvent) {
        const el = $(e.currentTarget);
        var empty = el.parent().children().length < 2;
        el.remove();
        if (empty) {
            this.fAlcoholEmptyList.show();
            this.fResetList.hide();
        }
    }

    fAlcoholListClear(e: JQuery.ClickEvent) {
        this.fAlcoholList.empty();
        this.inputChange(null);
        this.fAlcoholEmptyList.show();
        this.fResetList.hide();
    }

    calculate(e: JQuery.SubmitEvent) {
        super.calculate(e);

        this.dError.hide().html("");
        this.dResult.hide().html("");

        var pureAlcoholMl = 0;
        $.each(this.fAlcoholList.find("button"), (i, el) => {
            pureAlcoholMl += Number($(el).data("value"));
        });

        fetch(`${window.variables.calculatorBloodAlcoholCalculateUrl}?weightKg=${this.fWeightKg.val()}&sex=${this.fSex.val()}&pureAlcoholMl=${pureAlcoholMl}&timeHr=${this.fTimeHr.val()}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error("Network response was not OK");
                }
                return response.json();
            })
            .then((data: Adcsk.CalcBloodAlcoholResult) => {
                if (data.Error) {
                    this.dError.html(data.Msg).show();
                    if (data.WeightKgError) {
                        this.fWeightKg.parent().addClass("has-error");
                    }
                    if (data.PureAlcoholMlError) {
                        this.fAddAlcohol.parent().addClass("has-error");
                    }
                    return;
                }
                this.dResult.html(data.FormatedResult).show();
            })
            .catch(reason => {
                this.dError.text("Nastala neočakávaná chyba.").show();
            });

        return false;
    }
}
